import { tenancydic, creditaccounddic, organisation } from "./enums.model";

export interface BUSINESSGROUP {
  in_org_type: string;
  in_customer_name: string;
  in_entity_name: string;
  in_trust_name: string; //trustName
  in_ABN: string; //ABN
  in_ACN: string; //ACN
  in_RequestLimitCredit:string;

  in_date_business_started: string; //dataBusinessStart
  in_date_business_purchased: string; //datapurchased
  in_bank_contact: string; //bankingContact
  in_bank_address1: string; //bankDetail
  in_bank_address2: string; //bankDetail
  in_bank_address3: string; //bankDetail
  in_swift_address: string; //swiftAddress
  in_bank_account_name: string; //accountName
  in_bsb: string; //BSB
  in_account_number: string; //accountNumber
  //right
  //right
  //right
  //right
  in_incorporation_date: string;
  in_incorporation_place: string;
  in_estimated_monthly_purch: string;
  in_company_address1: string;
  in_company_address2: string;
  in_company_address3: string;
  in_company_postcode: string;
  in_company_country: string;
  in_company_suburb: string;
  in_company_street: string;

  in_parent_company: string;
  in_delivery_address1: string;
  in_delivery_address2: string;
  in_delivery_address3: string;
  in_tenancy: string; //not set front
  in_time_at_address: string;
  in_email: string;
  in_phonecode:string;
  in_phone: string;
  in_fax: string;
  in_company_website_url:string;
  in_required_credit: string; //not set yet
  in_online_contact: string;
  in_admin_email: string;
  in_password: string;
  in_part_ship: string; //not set yet

  in_delivery_street: string,
  in_delivery_suburb: string,
  in_delivery_country: string,
  in_delivery_postcode: string,
}

export interface DELIVERYMETHODARRAY {
  in_delivery_street: string;
  in_delivery_suburb: string;
  in_delivery_country: string;
  in_delivery_postcode: string;
}
//REG, SOLE, PART, TRUST,CLUB, INST, GOV, OTH
export class ORGTYPS {}

export const orgTypeToValue: Map<string, string> = new Map<string, string>();

export const orgType: Map<string, string> = new Map<string, string>();

orgTypeToValue.set("REG", "Registered Company");

orgTypeToValue.set("SOLE", "Sole Trader");
orgTypeToValue.set("PART", "Partnership");
orgTypeToValue.set("TRUS", "Trust");
orgTypeToValue.set("CLUB", "Club/Charity");
orgTypeToValue.set("INST", "Institution");
orgTypeToValue.set("GOV", "Government");
orgTypeToValue.set("OTH", "Other");

orgType.set("Registered Company", "REG");

orgType.set("Sole Trader", "SOLE");
orgType.set("Partnership", "PART");
orgType.set("Trust", "TRUST");
orgType.set("Club/Charity", "CLUB");
orgType.set("Institution", "INST");
orgType.set("Government", "GOV");
orgType.set("Other", "OTH");

export const tenancyType: Map<string, string> = new Map<string, string>();
export const tenancyTypeToValue: Map<string, string> = new Map<
  string,
  string
>();

tenancyType.set("Owned/Mortgage", "OWN");
tenancyType.set("Leased", "LEASE");

tenancyTypeToValue.set("OWN", "Owned/Mortgage");
tenancyTypeToValue.set("LEASE", "Leased");

//COD/10K/50K
export const creditType: Map<string, string> = new Map<string, string>();
export const creditTypeTypeToValue: Map<string, string> = new Map<string, string>();
//TODO: LATER CHANGE THE COD
creditType.set("C.B.D (<$10k per month)", "COD");
creditType.set("10 Day (>$10k per month)", "10K");
creditType.set("30 Day EOM (>$50k per month)", "50K");
//TODO: LATER CHANGE THE COD
creditTypeTypeToValue.set("COD","C.B.D (<$10k per month)");
creditTypeTypeToValue.set( "10K","10 Day (>$10k per month)");
creditTypeTypeToValue.set( "50K","30 Day EOM (>$50k per month)");



// WEBPACK FOOTER //
// ./src/app/model/businessgroup.model.ts